import { filter } from "lodash"
import apiAction from "../ajax/service"


const loadUniquesInField = async(source , filters = {},dispatch=undefined , reducer = undefined, limit = 100 , join = true)=>{

  filters = {...filters  }
  var data = await  apiAction('filters',{limit ,field : source , filters : filters , join } , 'getUniqueInField')
  // console.log(data)
  dispatch(reducer(data))
}


export {loadUniquesInField}
